// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OverlappingAvatars-cls1___ca5da39f55df086fa11{/*!*/}.OverlappingAvatars-cls2__ad6b54faa54d95133a71{}.OverlappingAvatars-cls2__ad6b54faa54d95133a71:not(:first-child){margin-left:-8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "OverlappingAvatars-cls1___ca5da39f55df086fa11",
	"cls2": "OverlappingAvatars-cls2__ad6b54faa54d95133a71 OverlappingAvatars-cls1___ca5da39f55df086fa11"
};
export default ___CSS_LOADER_EXPORT___;
